import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { registerUser, verifyOtp } from "../../services/authService";
import { getLangFromPath } from "../../utils/getLangFromPath ";

const initialState = {
  user: null,
  isLoggedIn: false,
  status: "idle",
  isRegistered: false,
  error: null,
  token: null,
  openedModal: false,
};
export const login = createAsyncThunk(
  "auth/login",
  async ({ email, password }, thunkAPI) => {
    try {
      const lang = getLangFromPath();
      const response = await axios.post(
        "https://eliteluxora.vps.webdock.cloud/api/auth/login",
        {
          email,
          password,
        },
        {
          headers: {
            "Accept-Language": lang,
          },
        }
      );
      if (response.data.success) {
        localStorage.setItem("token", response.data.token);

        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data.message);
      }
    } catch (error) {
      return thunkAPI.rejectWithValue("Something went wrong");
    }
  }
);
export const register = createAsyncThunk(
  "auth/register",
  async ({ email }, { rejectWithValue }) => {
    try {
      const response = await registerUser(email);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const verifyOtpCode = createAsyncThunk(
  "auth/verifyOtp",
  async (data, { rejectWithValue }) => {
    const tempData = {
      email: data?.email,
      otp: data?.otp,
      password: data?.password,
      passwordConfirm: data?.passwordConfirm,
    };

    try {
      const lang = getLangFromPath();
      const response = await axios.post(
        "https://eliteluxora.vps.webdock.cloud/api/auth/verify-otp",
        tempData,
        {
          headers: {
            "Content-Type": "application/json",
            "Accept-Language": lang,
          },
        }
      );
      return response?.data;
    } catch (error) {
      rejectWithValue(error.message);
    }
  }
);
export const sendGoogleToken = createAsyncThunk(
  "auth/sendToken",
  async ({ token }, thunkAPI) => {
    try {
      const lang = getLangFromPath();
      const response = await axios.get(
        "https://eliteluxora.vps.webdock.cloud/api/auth/firebase",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": lang,
          },
        }
      );
      localStorage.setItem("token", response.data.token);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      state.user = null;
      state.isLoggedIn = false;
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      delete axios.defaults.headers.common["Authorization"];
    },
    setUserFromStorage: (state) => {
      const token = localStorage.getItem("token");
      const user = localStorage.getItem("user");
      if (token && user) {
        state.token = token;
        state.user = user;
        state.isLoggedIn = true;
      }
    },
    openLoginModal: (state, action) => {
      state.openedModal = action.payload;
    },

    setUserCredentials: (state, action) => {
      state.token = action.payload.token;
      state.user = action.payload.user;
    },
    loginWithGoogle: (state, action) => {
      state.user = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(register.fulfilled, (state, action) => {
        state.isRegistered = true;
      })
      .addCase(register.rejected, (state, action) => {
        state.isRegistered = false;
        state.error = action.payload;
      })
      .addCase(verifyOtpCode.fulfilled, (state, action) => {
        // state.user = action.payload.user;
        // state.isLoggedIn = true;
        state.error = null;
        // localStorage.setItem("user", JSON.stringify(action.payload.user));
      })
      .addCase(verifyOtpCode.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(login.pending, (state) => {
        state.status = "loading";
      })
      .addCase(login.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.user = action.payload.user;
        state.isLoggedIn = true;
        localStorage.setItem("user", JSON.stringify(action.payload.user));
        localStorage.setItem("token", JSON.stringify(action.payload.token));
      })
      .addCase(login.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
    builder
      .addCase(sendGoogleToken.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(sendGoogleToken.fulfilled, (state, action) => {
        state.status = "succeeded";
      })
      .addCase(sendGoogleToken.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});
export const {
  logout,
  setUserCredentials,
  setUserFromStorage,
  openLoginModal,
} = authSlice.actions;
export default authSlice.reducer;
